module.exports = __webpack_public_path__ + "img/1586649161.0bc93cbe.jpg";